/* global translationsCheckout */
/* global validate_checkout_step_ajax */
/* global store_credit_params */

export default {
  init() {
    if (!$('body').hasClass('woocommerce-order-received')) {
      // JavaScript to be fired on the checkout page
      initializeWoocommerceCheckout();
      validation();
      dhl_postnum_field();
      display_address_fields();
      field_is_required();
      clearCustomerInfo();
      use_store_credit_in_checkout();
      forceSelect2Fields();
      prevent_woo_validation_conflict();
      //showTooltip();
    }
  },
  finalize() {
    de_shipping_fields_changes();
    checkOutSteps();
    change_required_label();
    customize_place_order_button();
    // JavaScript to be fired on the checkout page, after the init JS
  },
};

export var forceSelect2Fields = () => {
  let $countryFields = $('#billing_country, #shipping_country, #billing_state, #shipping_state');

  $countryFields.each(function() {
    let $this = $(this);

    if ($this.length > 0 && $this.is('select') && !$this.next('.select2-container').length) {
      if (typeof $.fn.selectWoo !== 'undefined') {
        $this.selectWoo({ width: '100%' });
      } else if (typeof $.fn.select2 !== 'undefined') {
        $this.select2({ width: '100%' });
      }
    }
  });
};

export var validation = () => {
  let billingHouseNumber = $('#billing_house_number');
  let shippingHouseNumber = $('#shipping_house_number');

  billingHouseNumber.on('input', window.WSGlobalFunctions.debounce(function () {
    streetHouseNumberCheck('billing');
  }, 500));

  shippingHouseNumber.on('input', window.WSGlobalFunctions.debounce(function () {
    streetHouseNumberCheck('shipping');
  }, 500));

  $(document.body).on('input change', '.woocommerce-checkout input, .woocommerce-checkout select, .woocommerce-checkout textarea', function() {
    let $wrapper = $(this).closest('p');
    $wrapper.removeClass('woocommerce-invalid woocommerce-invalid-required-field');
    // Alleen verwijderen als het geen specifieke Duitse PLZ foutmelding is
    $wrapper.find('.error-message').not('.ws-error-message').remove();
  });

  if (translationsCheckout.currentSite === 'wolky.de') {
    $(document.body).on('input', '#billing_postcode, #shipping_postcode', function() {
      let $field = $(this);
      let value = $field.val();
      let $wrapper = $field.closest('p');

      // Verwijder alleen de Duitse PLZ foutmelding
      $wrapper.removeClass('woocommerce-invalid woocommerce-invalid-required-field');
      $wrapper.find('.ws-error-message').remove();

      // Validatie
      if (value !== '' && !/^[0-9]{5}$/.test(value)) {
        $wrapper.addClass('woocommerce-invalid woocommerce-invalid-required-field');
        $wrapper.append('<span class="error-message ws-error-message">' + translationsCheckout.postcodeError + '</span>');
      }
    });
  }

  // Add validation for UK site to disallow only numbers in street
  if (translationsCheckout.currentSite === 'wolky.co.uk') {
    $('.woocommerce-checkout').on('blur', '#billing_street, #shipping_street', function() {
      let $field = $(this);
      let value = $field.val();

      if (value !== '' && /^[0-9]+$/.test(value)) {
        let $wrapper = $field.closest('p');
        if (!$wrapper.find('.error-message').length) {
          $wrapper.addClass('woocommerce-invalid woocommerce-invalid-required-field');
          $wrapper.append('<span class="error-message">' + translationsCheckout.streetOnlyNumbersError + '</span>');
        }
      }
    });
  }
}

export var streetHouseNumberCheck = (type) => {
  let street = $('#' + type + '_street');
  let houseNumber = $('#' + type + '_house_number');
  let houseNumberWarning = $('.' + type + '-house-number-warning');

  if (similtude(street.val().toLowerCase(), houseNumber.val().toLowerCase()) > 50 || street.val().toLowerCase() === houseNumber.val().toLowerCase()) {
    if (!houseNumberWarning.length) {
      $('#' + type + '_house_number_field').append('<p class="' + type + '-house-number-warning">' + translationsCheckout.houseNumberTranslation + '</p>');
    }
  } else {
    if (houseNumberWarning.length) {
      houseNumberWarning.remove();
    }
  }
}

export var similtude = (a, b) => {
  for (var i = 0, len = Math.max(a.length, b.length); i < len; i++)
    if (a.charAt(i) !== b.charAt(i))
      return Math.round(i / len * 100);
}

export var initializeWoocommerceCheckout = () => {
  // Move paypal button
  $('.ppc-button-wrapper').appendTo('.checkout-step-3');

  $('#ship-to-different-address-checkbox').on('click', function() {
    if($('#ship-to-different-address-checkbox').is(':checked') ) {
      if(!$('#shipping_state').hasClass('select2-hidden-accessible')) {
        $('#shipping_state').select2({
          width: '100%',
        });
      }
    }
  });

  const billingStreet = $('#billing_street');
  const billingHouseNumber = $('#billing_house_number');
  const hiddenBillingAddress1 = $('#billing_address_1');

  const shippingStreet = $('#shipping_street');
  const shippingHouseNumber = $('#shipping_house_number');
  const hiddenShippingAddress1 = $('#shipping_address_1');

  let updateHiddenBillingAddress1 = function () {
    let addrArray = [];

    if (billingStreet.val().trim() !== '') {
      addrArray.push(billingStreet.val().trim());
    }

    if (billingHouseNumber.val().trim() !== '') {
      addrArray.push(billingHouseNumber.val().trim());
    }

    if(addrArray.length > 0) {
      hiddenBillingAddress1.val(addrArray.join(' '));
    }
  }

  let updateHiddenShippingAddress1 = function () {
    let addrArray = [];

    if (shippingStreet.val().trim() !== '') {
      addrArray.push(shippingStreet.val().trim());
    }

    if (shippingHouseNumber.val().trim() !== '') {
      addrArray.push(shippingHouseNumber.val().trim());
    }

    if(addrArray.length > 0) {
      hiddenShippingAddress1.val(addrArray.join(' '));
    }
  }

  updateHiddenBillingAddress1();
  updateHiddenShippingAddress1();

  billingStreet.change(updateHiddenBillingAddress1);
  billingHouseNumber.change(updateHiddenBillingAddress1);

  shippingStreet.change(updateHiddenShippingAddress1);
  shippingHouseNumber.change(updateHiddenShippingAddress1);

  $('.woocommerce-checkout #shipping_dhl_address_type').change(function () {
    // This triggers before the field is updated, so lets wait for a split second
    setTimeout(function () {
      const values = $('#shipping_address_1').val().split(' ');

      let street = '';
      for (let i = 0; i < values.length - 1; i++) {
        street += values[i];
      }

      const packstationNumber = values.pop();

      shippingStreet.val(street);
      shippingHouseNumber.val(packstationNumber);

    }, 1);
  });
}

export var prevent_woo_validation_conflict = () => {
  if (translationsCheckout.currentSite !== 'wolky.de') return;

  const removeValidation = () => {
    $('#billing_postcode_field, #shipping_postcode_field').each(function() {
      const $el = $(this);
      const val = $el.find('input').val();

      // Als de waarde niet exact 5 cijfers is OF leeg is (maar niet leeg mag zijn),
      // verwijder dan direct de klasse 'woocommerce-validated'
      if (val !== '' && !/^[0-9]{5}$/.test(val)) {
        if ($el.hasClass('woocommerce-validated')) {
          $el.removeClass('woocommerce-validated');
        }
      }
    });
  };

  // Luister naar input, blur, en de WooCommerce AJAX update event
  $(document.body).on('input blur change', '#billing_postcode, #shipping_postcode', removeValidation);
  $(document.body).on('updated_checkout', removeValidation);
};

export var dhl_postnum_field = () => {
  if ($('#shipping_dhl_address_type')[0]) {
    address_type();
    $(document.body).on('change', '#shipping_dhl_address_type', address_type);
  }

  function address_type() {
    let requiredElement = $('label span.required').first();
    let address_type = $('.woocommerce-checkout #shipping_dhl_address_type').val();
    let postnumLabel = $('.woocommerce-checkout #shipping_dhl_postnum_field label');
    let postnumField = $('.woocommerce-checkout #shipping_dhl_postnum');

    postnumLabel.find('.required').remove();
    postnumField.removeAttr('required');
    $('#shipping_dhl_postnum_field').removeClass('validate-required');

    if (address_type === 'dhl_branch' || address_type === 'dhl_packstation') {
      postnumLabel.append(requiredElement.clone());
      postnumField.attr('required', 'required');
      $('#shipping_dhl_postnum_field').addClass('validate-required');
    }
  }
}

export var de_shipping_fields_changes = () => {
  let fieldsToDisable = $('#shipping_street, #shipping_house_number, #shipping_postcode, #shipping_city, #select2-shipping_state-container, #select2-shipping_country-container');

  let shipping_address_type = $('#shipping_dhl_address_type');
  /* Check if the dhl fields are present */
  if (shipping_address_type[0]) {

    /* Move the address type selector to the top so the user first selects this */
    $('#shipping_dhl_address_type_field').prependTo($('.shipping_address'));

    hide_shipping_fields(shipping_address_type, fieldsToDisable);

    shipping_address_type.on('change', function () {
      hide_shipping_fields(shipping_address_type, fieldsToDisable);
    });

    $(document.body).on('click', '.parcelshop-select-btn', function () {
      $('.woocommerce-shipping-fields__field-wrapper').show();
      fieldsToDisable.attr('readonly', true);
    });
  }

  function hide_shipping_fields(shipping_address_type, fieldsToDisable) {
    let parcel_finder = $('#dhl_parcel_finder');
    let shipping_fields = $('.woocommerce-shipping-fields__field-wrapper');

    parcel_finder.on('click', function () {
      if (shipping_address_type.val() === 'dhl_packstation') {
        $('#dhl_packstation_filter').prop('checked', true);
        $('#dhl_branch_filter').prop('checked', false);
      }

      if (shipping_address_type.val() === 'dhl_branch') {
        $('#dhl_packstation_filter').prop('checked', false);
        $('#dhl_branch_filter').prop('checked', true);
      }
    });

    if (shipping_address_type.val() === 'dhl_packstation' || shipping_address_type.val() === 'dhl_branch') {
      shipping_fields.hide();
      parcel_finder.show();
    } else {
      shipping_fields.show();
      parcel_finder.hide();
      fieldsToDisable.attr('readonly', false)
    }
  }
}

export var display_address_fields = () => {
  $(document).ready(function () {
    change_required_label();
    toggle_address_fields('billing');
    toggle_address_fields('shipping');
  });

  $(document).on('change', '#billing_country', function () {
    toggle_address_fields('billing');
    change_required_label();
  });

  $(document).on('change', '#shipping_country', function () {
    toggle_address_fields('shipping');
    change_required_label();
  });

  function toggle_address_fields(type) {
    let country = $('#' + type + '_country').val();
    let street = $('#' + type + '_street_field');
    let house_number = $('#' + type + '_house_number_field');
    let postal_code = $('#' + type + '_postcode_field');
    let city = $('#' + type + '_city_field');
    let address_1 = $('#' + type + '_address_1_field');
    let address_2 = $('#' + type + '_address_2_field');

    if (country === 'NL' || country === 'BE') {
      field_is_required();

      /* Show custom dutch address fields */
      street.show();
      house_number.show();

      postal_code.detach().insertBefore(house_number);
      street.detach().insertBefore(city);

      /* Hide Woocommerce default address fields */
      address_1.hide();
      address_2.hide();
    } else {
      if(country === 'DE') {
        field_is_required();

        /* Show custom dutch address fields */
        street.show();
        house_number.show();

        street.detach().insertBefore(house_number);
        house_number.detach().insertAfter(street);
        postal_code.detach().insertBefore(city);

        /* Hide Woocommerce default address fields */
        address_1.hide();
        address_2.hide();
      } else {
        /* Hide custom dutch address fields */
        street.hide();
        house_number.hide();

        /* Show Woocommerce default address fields */
        address_1.show();
        address_2.show();

        address_2.detach().insertAfter(address_1);
        postal_code.detach().insertBefore(city);
      }
    }
  }
}

export var change_required_label = () => {
  if (typeof wc_address_i18n_params === 'undefined') {
    return;
  }

  $('.woocommerce form .required').text('(' + translationsCheckout.requiredTranslation + ')');
}

export var field_is_required = () => {
  $(document).ready(function () {
    required_or_optional('billing'); //this calls it on load
    required_or_optional('shipping'); //this calls it on load
    $('#billing_country').change(required_or_optional('billing'));
    $('#shipping_country').change(required_or_optional('shipping'));

    function required_or_optional(type) {
      let house_number = type + '_house_number';
      let street = type + '_street';
      let address_1 = type + '_address_1';
      let address_2 = type + '_address_2';
      let countrySelectValue = $('#' + type + '_country').val();

      if (countrySelectValue === 'NL' || countrySelectValue === 'BE' || countrySelectValue === 'DE') {
        let requiredElement = $('label span.required').first();

        /* Require street*/
        $('#' + street + '_field').addClass('validate-required');
        $('#' + street).prop('required', true);
        $('label[for="' + street + '"] .optional').remove();
        if (!$('label[for="' + street + '"] > span.required').hasClass('required')) {
          $('label[for="' + street + '"]').append(requiredElement.clone());
        }

        /* Require house number */
        $('#' + house_number + '_field').addClass('validate-required');
        $('#' + house_number).prop('required', true);
        $('label[for="' + house_number + '"] .optional').remove();
        if (!$('label[for="' + house_number + '"] > span.required').hasClass('required')) {
          $('label[for="' + house_number + '"]').append(requiredElement.clone());
        }

        $('#' + address_1).removeProp('required');
        $('#' + address_2).removeProp('required');

        $('label[for="' + address_1 + '"] .required').remove();
        $('label[for="' + address_2 + '"] .required').remove();
      } else {
        /* Make street optional */
        $('label[for="' + street + '"] .required').remove();
        $('#' + street).removeProp('required');
        $('#' + street + '_field').removeClass('validate-required');

        /* Make house number optional */
        $('label[for="' + house_number + '"] .required').remove();
        $('#' + house_number).removeProp('required');
        $('#' + house_number + '_field').removeClass('validate-required');

        $('#' + address_1 + '_field').addClass('validate-required');
        $('#' + address_1).prop('required', true);
        if (!$('label[for="' + address_1 + '"] > span.required').length) {
          let requiredElement = $('label span.required').first();
          $('label[for="' + address_1 + '"]').append(requiredElement.clone());
        }
      }
    }
  });
}

export var clearCustomerInfo = () => {
  $('#clear-customer-info').on('click', function() {
    $('#shipping_first_name').val('');
    $('#shipping_last_name').val('');
    $('#shipping_email').val('');
    $('#shipping_phone').val('');
    $('#shipping_street').val('');
    $('#shipping_postcode').val('');
    $('#shipping_city').val('');
    $('#shipping_house_number').val('');
    $('#shipping_address_1').val('');
    $('#shipping_address_2').val('');

    return false;
  });
}

export var checkOutSteps = () => {
  let checkoutSteps = 3;
  //let currentStep = 1;

  // Get translated step slug (e.g., 'step' in English, 'stap' in Dutch)
  const stepSlug = translationsCheckout.stepSlug || 'step';

  // Helper to read the step from URL hash like "#step-1" or "#stap-1"
  const getCurrentStepFromHash = () => {
    const m = (window.location.hash || '').trim().match(new RegExp(`^#?${stepSlug}-(\\d+)$`, 'i'));
    return m ? parseInt(m[1], 10) : null;
  };

  // Initialize the current step from the URL hash (fallback to 1)
  let currentStep = getCurrentStepFromHash() || 1;


  const syncStepFromLocation = () => {
    const stepFromHash = getCurrentStepFromHash();
    if (stepFromHash && stepFromHash !== currentStep) {
      const clamped = Math.min(Math.max(1, stepFromHash), checkoutSteps);
      showStep(clamped);
    }
  };

  $(window).on('hashchange', syncStepFromLocation);
  $(window).on('popstate', syncStepFromLocation);
  $(window).on('pageshow', function (e) {
    if (e.originalEvent && e.originalEvent.persisted) {
      syncStepFromLocation();
    }
  });



  $(document).ajaxStop(function() {

  });

  $(document).on('click', '.button-next-step', function () {
    if (currentStep >= checkoutSteps) {
      return;
    }

    $('.woocommerce-checkout p').removeClass('woocommerce-invalid woocommerce-invalid-required-field');
    $('.woocommerce-checkout .error-message').remove();

    $.ajax({
      url: validate_checkout_step_ajax.wc_ajax_url.replace('%%endpoint%%', 'validate_checkout_step'),
      type: 'POST',
      data: {
        checkout_step: currentStep,
        post_data: $('.woocommerce-checkout').serialize(),
      },
      success: function (response) {
        if(response.success === false) {
          var errors = response.data.errors;
          var firstErrorField = null;

          $.each(errors, function (field, message) {
            var $fieldWrapper = $('#' + field).closest('p');

            $fieldWrapper.addClass('woocommerce-invalid woocommerce-invalid-required-field');
            $fieldWrapper.find('.error-message').remove();
            $fieldWrapper.append('<span class="error-message">' + message + '</span>');

            if (firstErrorField === null) {
              firstErrorField = $fieldWrapper;
            }
          });

          if (firstErrorField && firstErrorField.length) {
            let headerHeight = $('.header').outerHeight() || 160;
            if ($('#wpadminbar').length > 0) {
              headerHeight += $('#wpadminbar').height();
            }

            const targetScroll = Math.max(0, firstErrorField.offset().top - (headerHeight + 100));

            $('html, body').stop().animate({
              scrollTop: targetScroll,
            }, 500);
          }
        }

        // Check if validation was successful
        if (response.success) {
          // Clear all error messages on successful validation
          $('.error-message').remove();
          $('.woocommerce-invalid').removeClass('woocommerce-invalid woocommerce-invalid-required-field');

          showStep(parseInt(currentStep) + 1);
        }

        if(currentStep === 2) {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'add_shipping_info',
            user_data: {
              email: $('#billing_email').val(),
              first_name: $('#billing_first_name').val(),
              last_name: $('#billing_last_name').val(),
              phone: $('#billing_phone').val(),
              street: $('#billing_address_1').val(),
              city: $('#billing_city').val(),
              zip: $('#billing_postcode').val(),
              country: $('#billing_country').val(),
            },
          });
        }

        if(currentStep === 3) {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'add_payment_info',
            user_data: {
              email: $('#billing_email').val(),
              first_name: $('#billing_first_name').val(),
              last_name: $('#billing_last_name').val(),
              phone: $('#billing_phone').val(),
              street: $('#billing_address_1').val(),
              city: $('#billing_city').val(),
              zip: $('#billing_postcode').val(),
              country: $('#billing_country').val(),
            },
          });
        }

        $(document.body).trigger('update_checkout');
      },
      error: function (xhr) {
        var errors = xhr.responseJSON;

        // Display error messages next to respective form fields
        $.each(errors, function (field, message) {
          // Update error message for the field
          $('#' + field + '_error').html(message);
        });
      },
    });
  });

  $(document).on('click', '.change', function () {
    let clickedElementNumber = $(this).attr('data-change-number');

    showStep(clickedElementNumber);
  });

  // Clear error messages when user interacts with fields
  $(document).on('input change keyup keydown blur focusin', '.woocommerce-checkout input, .woocommerce-checkout select, .woocommerce-checkout textarea', function () {
    var $field = $(this);
    var $fieldWrapper = $field.closest('p');

    // Remove error message and invalid class when user starts filling the field
    if ($fieldWrapper.hasClass('woocommerce-invalid')) {
      $fieldWrapper.removeClass('woocommerce-invalid woocommerce-invalid-required-field');
      $fieldWrapper.find('.error-message').remove();
    }
  });

  let showStep = (step) => {
    $('.checkout-step-container').removeClass('current-step');

    for (let i = 1; i < step; i++) {
      $('.checkout-step-container-step-' + i).addClass('completed-step');
    }

    currentStep = step;
    const elCurrentStep = $('.checkout-step-container-step-' + currentStep);
    elCurrentStep.addClass('current-step');

    $('.checkout-stepper').removeClass('step-1 step-2 step-3').addClass('step-' + currentStep);
    window.location.hash = '#' + stepSlug + '-' + currentStep;

    calculateSummaries();

    setTimeout(() => {
      const isMobile = $(window).width() <= 1024;
      let targetScroll = 0;
      let headerHeight = $('.header').outerHeight() || 80;
      if ($('#wpadminbar').length > 0) headerHeight += $('#wpadminbar').height();

      if (currentStep === 1) {
        targetScroll = $('.checkout-stepper').offset().top - (headerHeight + 120);
      }
      else if (currentStep === 2) {
        if (isMobile) {
          targetScroll = $('.checkout-step-container-step-2 h2').offset().top - (headerHeight + 40);
        } else {
          targetScroll = $('.checkout-step-container-step-1 h2').offset().top - (headerHeight + 100);
        }
      }
      else if (currentStep === 3) {
        if (isMobile) {
          targetScroll = $('.checkout-step-container-step-3 h2').offset().top - (headerHeight + 40);
        } else {
          targetScroll = $('.checkout-step-container-step-3').offset().top - (headerHeight + 150);
        }
      }

      $('html, body').stop().animate({
        scrollTop: Math.max(0, targetScroll),
      }, 300);
    }, 50);
  };

  let calculateSummaries = () => {
    $('.checkout-step-container .summary').each(function () {
      let el = $(this);
      let stepElement = el.closest('.checkout-step-container');

      el.find('[data-field]').each(function () {
        let el2 = $(this);
        let fieldName = el2.data('field');
        let field = stepElement.find('[name="' + fieldName + '"]');

        let value = '';

        let fieldType = field.attr('type') || field.prop('tagName');

        if(fieldType === undefined) {
          return;
        }

        fieldType = fieldType.toLowerCase();

        if (fieldName === 'billing_country' || fieldName === 'shipping_country') {
          let countrySpan = field.closest('.woocommerce-input-wrapper').find('strong');
          if (countrySpan.length) {
            value = countrySpan.html();
          } else {
            value = field.val();
          }
        } else if (fieldName.startsWith('shipping_method') && fieldType === 'hidden') {
          let fieldId = field.attr('id');
          let label = stepElement.find('label[for="' + fieldId + '"]');
          if(label.length) {
            value = label.html();
          } else {
            value = field.val();
          }
        } else if(fieldType === 'hidden') {
          value = field.val();
        } else if (fieldType === 'checkbox' || fieldType === 'radio') {
          field = stepElement.find('[name="' + fieldName + '"]:checked');
          let label = stepElement.find('label[for="' + field.attr('id') + '"]');
          value = label.html();
        } else if (fieldType === 'select') {
          let label = field.find('option:selected');
          value = label.html();
        } else {
          value = field.val();
        }

        el2.html(value);
      })
    });
  };


  showStep(currentStep);
}

export var use_store_credit_in_checkout = () => {
  $(document).on('change', '#store-credit-checkbox', function(e) {
    e.preventDefault();

    let action = 'remove_store_credit';
    if (this.checked) {
      action = 'enable_store_credit';
    }

    $.post(
      store_credit_params.wc_ajax_url.replace('%%endpoint%%', action),
      {},
      function () {
        $( document.body ).trigger( 'update_checkout' );
      }
    );
  });
}

export var customize_place_order_button = () => {
  // Function to update the Place Order button
  function customizePlaceOrderButton() {
    const placeOrderButton = $('#place_order');
    if (placeOrderButton.length) {
      let icon = '<i><svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 320 512"><path d="M278.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 256 73.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z"/></svg></i>';

      placeOrderButton.html(placeOrderButton.html() + icon);
    }
  }

  // Run the customization function on page load
  customizePlaceOrderButton();

  // Trigger the function when WooCommerce updates the checkout (AJAX updates)
  $(document.body).on('updated_checkout', function() {
    customizePlaceOrderButton();
    forceSelect2Fields();
  });

  $(document.body).on('payment_method_selected', function () {
    customizePlaceOrderButton();
  });
}
